import React, { useEffect, useRef, useState } from "react";
import { Header } from "../../features/landing";
import { useLocation } from "react-router-dom";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [showHeader, setShowHeader] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);
  const location = useLocation();
  const prevPathRef = useRef(location.pathname);
  const isInitialMount = useRef(true);

  useEffect(() => {
    // 初回マウント時は何もしない
    if (isInitialMount.current) {
      isInitialMount.current = false;
      return;
    }

    // トップ画面への遷移時のみスクロール位置をリセット
    if (location.pathname === "/" && prevPathRef.current !== "/") {
      requestAnimationFrame(() => {
        window.scrollTo({
          top: 0,
          behavior: "instant"
        });
      });
    }
    prevPathRef.current = location.pathname;

    // ページ遷移時に初期化
    if (location.pathname === "/") {
      setShowHeader(false);
    }

    const handleScroll = () => {
      const scrollTop = window.scrollY;

      // 特定のページではHeaderを表示しない
      if (location.pathname === "/lunchmenu" || 
          location.pathname === "/dinnermenu" || 
          location.pathname === "/takeoutmenu" || 
          location.pathname === "/ourthoughts" || 
          location.pathname === "/brownrice") {
        setShowHeader(false);
        return;
      }

      if (scrollTop > lastScrollY && scrollTop > 100) {
        setShowHeader(true);
      } else if (scrollTop < 100) {
        setShowHeader(false);
      }

      setLastScrollY(scrollTop);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [lastScrollY, location.pathname]);

  return (
    <>
      {showHeader && <Header />}
      {children}
    </>
  );
};

export default Layout; 